<template>
    <section>
        <sy-baselist
                editVue="./system/SetType_Edit.vue"
                :fixWhere="'dicType='+dicTypeID"
                :filters="filters"
                @beforeAdd="beforeAdd"
                listUrl="server/system/SetType.ashx?cmd=GetList"
                deleteUrl="server/system/SetType.ashx?cmd=Delete"
        >
            <el-table-column prop="name" :label="dicTypeName" width="400" sortable>
            </el-table-column>
            <el-table-column prop="note" label="备注" width="200" sortable>
            </el-table-column>
        </sy-baselist>
    </section>
</template>

<script>
    import util from '../../common/util'
    export default {
        data(){
            return {
                dicTypeID:'',
                dicTypeNameGroup:['电子标签类型'],
                dicTypeName:'',
                filters: [{type: "string",name:"name",text:'电子标签类型', value: ""}]
            }
        },
        methods:{
            beforeAdd(row){
                row.dicTypeID = this.dicTypeID
            }
        },
        created(){
            console.log("created:")
            this.dicTypeID = this.$router.currentRoute.query.dicTypeID;
            if(this.dicTypeID){
                this.dicTypeName = this.dicTypeNameGroup[this.dicTypeID-1]
                console.log("dicTypeName:" + this.dicTypeName)
            }
       }
    }
</script>



// WEBPACK FOOTER //
// src/pages/system/SetType.vue